/**
 * Users API
 * - 사용자 관련 API 호출
 */
import client from './client';

export interface UserStats {
  totalAlbums: number;
  publicAlbums: number;
  totalLikes: number;
  totalBookmarks: number;
}

export interface PublicProfile {
  _id: string;
  name: string;
  profileImage?: string;
  createdAt: string;
  stats: { publicAlbums: number; totalLikes: number };
  albums: any[];
}

export const getMyStats = async (): Promise<UserStats> => {
  const res = await client.get('/users/me/stats');
  return res.data;
};

export const getPublicProfile = async (userId: string): Promise<PublicProfile> => {
  const res = await client.get(`/users/${userId}/public`);
  return res.data;
};
